import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { ResearchApproach } from './components/ResearchApproach';
import { Certification } from './components/Certification';
import { FeaturedResearch } from './components/FeaturedResearch';
import { ProductReviews } from './components/ProductReviews';
import { MediaInsights } from './components/MediaInsights';
import { SupportCTA } from './components/SupportCTA';
import { Footer } from './components/Footer';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
export function App() {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-0" data-mp="2wjgpfdsj9neb">
      <Navbar data-id="element-1" data-mp="2whx8rm2ytac0" />
      <main data-id="element-2" data-mp="2wi5pxq64f1t0">
        <Hero data-id="element-3" data-mp="28u5zkrcq1dey" />
        <About data-id="element-4" data-mp="28tmfb3zlmcxr" />
        <ResearchApproach data-id="element-5" data-mp="28te3zgj4jfoo" />
        <FeaturedResearch data-id="element-6" data-mp="28skzynbjv4a8" />
        <Certification data-id="element-7" data-mp="23vcikoy874a1" />
        <ProductReviews data-id="element-8" data-mp="23w4g45bdvc2y" />
        <MediaInsights data-id="element-9" data-mp="23utcc5hxu4bu" />
        <SupportCTA data-id="element-10" data-mp="23t8gmcjw0fce" />
      </main>
      <Footer data-id="element-11" data-mp="3ikh8ubu2yx01" />
    </div>;
}